// extracted by mini-css-extract-plugin
export default {"pageBg":"styles_pageBg__GW5Yx","pageTitle":"styles_pageTitle__MusRq","screenerLogo":"styles_screenerLogo__yugIm","tabView":"styles_tabView__tlW+K"};